import React from 'react';
import * as ReactBootstrap from 'react-bootstrap';

class AlertDismissable extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.dismissHandler = this.dismissHandler.bind(this);
        this.showHandler = this.showHandler.bind(this);
        this.scrollHandler = this.scrollHandler.bind(this);

        this.state = {
            show: false
        };
    }
    dismissHandler() {
        var feedback = document.getElementById('feedback');
        if (feedback) {
            if (feedback.classList.contains('fade')) {
                feedback.classList.remove('fade');
            }
        }
        this.timer = setTimeout(
            () => {
                this.setState({ show: false });
                clearTimeout(this.timer);
            },
            1000
        );
    }
    componentDidUpdate() {
        var feedback = document.getElementById('feedback');
        if (feedback) {
            if (this.state.show) {
                if (!feedback.classList.contains('fade')) {
                    feedback.classList.add('fade');
                }
                this.scrollHandler();
            }
        }
        window.addEventListener('scroll', this.scrollHandler);
    }
    componentWillUnmount() {
        clearTimeout(this.timer);
        window.removeEventListener('scroll', this.scrollHandler);
    }
    scrollHandler() {
        var top = window.pageYOffset || document.documentElement.scrollTop
        var feedback = document.getElementById('feedback');
        if (feedback) {
            feedback.style = "top: " + (top + 10) + "px;";
        }
    }
    showHandler(message, status) {
        clearTimeout(this.timer);
        this.setState({
            show: true,
            message: message,
            status: status
        });
        var timeout = this.props.timeout;
        if (status !== "success") {
            timeout = timeout * 2;
        }
        this.timer = setTimeout(
            this.dismissHandler,
            timeout
        );
    }

    render() {
        if (this.state.show) {
            return (
                <div id="feedback">
                    <ReactBootstrap.Alert
                        variant={this.state.status === "success" ? "success" : "danger"}
                        onClose={this.dismissHandler}
                        dismissible
                        style={{ width: "1000px", height: "50px" }}
                    >
                        <div className="col-md-10">
                            {this.state.message}
                        </div>
                    </ReactBootstrap.Alert>
                </div>
            );
        }

        return "";
    }
}

export default AlertDismissable;